import { FC, useRef } from 'react'
import { Tooltip } from 'react-tooltip'
import { styled, keyframes } from 'styled-components'
import { PopoverButton } from './buttons/tooltipButton'
import { TooltipContainer } from './helpTooltip'

const popoverFadeIn = keyframes`
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
`

const Container = styled(TooltipContainer)`
    .tooltip-container {
        padding: 0;
        animation: ${popoverFadeIn} 0.2s ease-out;
    }
`

const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;

    > *:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }

    > *:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }
`

interface Props {
    id: string
    items: PopoverItem[]
}

export interface PopoverItem {
    label: string
    onClick: () => void
}

export const Popover: FC<Props> = ({ id, items }) => {
    const tooltipRef = useRef<any>(null)

    const handleItemClick = (onClick: () => void) => {
        // Close the tooltip first
        if (tooltipRef.current) {
            tooltipRef.current.close()
        }
        // Then execute the item's onClick handler
        onClick()
    }

    return (
        <Container>
            <Tooltip
                ref={tooltipRef}
                anchorSelect={`#${id}`}
                className="tooltip-container"
                place="bottom-end"
                openOnClick={true}
                clickable={true}
                render={() => (
                    <ButtonsContainer>
                        {items.map((item) => (
                            <PopoverButton
                                key={item.label}
                                height="small"
                                width="fill"
                                onClick={() => handleItemClick(item.onClick)}
                            >
                                {item.label}
                            </PopoverButton>
                        ))}
                    </ButtonsContainer>
                )}
            />
        </Container>
    )
}
